module.exports = __webpack_public_path__ + "img/icon-service-system-1.fe2b6c16.svg";